module.exports = __webpack_public_path__ + "img/20f11.aeef30cb.jpg";